import { useCallback, useEffect } from 'react';
import { usePageVisibility } from 'react-page-visibility';
import { useIdleTimer } from 'react-idle-timer';
import { getActivityEventLogInput } from '@ui/components/student/screen/LearningScreen/hooks/useLearningSession';
import { APP_SESSION_TIMEOUT } from '@shared/constants/appSession';
import { useAppSessionCreateMutation } from '@ui/mutations/appSessionCreate';
import { useBeforeunload } from 'react-beforeunload';
import useCustomRouter from '@ui/hooks/useCustomRouter';

const AppSession = () => {
  const router = useCustomRouter();
  const createAppSession = useAppSessionCreateMutation();
  const isVisible = usePageVisibility();

  const isStudy = router.asPath?.startsWith('/study-module');

  // 세션 만료
  const onIdle = useCallback(async () => {
    const appSessionInput = await getActivityEventLogInput({
      connectionState: 'SESSION_EXPIRATION',
    });
    createAppSession({
      variables: {
        ...appSessionInput,
      },
    });
  }, [createAppSession]);

  useIdleTimer({
    timeout: APP_SESSION_TIMEOUT,
    onIdle,
  });

  // 페이지 종료
  useBeforeunload(() => {
    createAppSession({
      variables: {
        input: {
          logs: {
            type: 'ACTIVITY_EVENT_LOG',
            createdAt: new Date().toISOString(),
            items: {
              title: document.title,
              connectionState: 'SESSION_EXPIRATION',
              device: navigator.userAgent,
              activityTime: '00:00:00',
            },
          },
        },
      },
    });
  });

  useEffect(() => {
    const sendCreateAppSession = async () => {
      // 포커스 인
      let input = await getActivityEventLogInput({
        connectionState: 'ON',
        title: isStudy ? '' : document.title,
      });
      // 포커스 아웃
      if (!isVisible) {
        input = await getActivityEventLogInput({ connectionState: 'FOCUS_OUT' });
      }
      createAppSession({
        variables: {
          ...input,
        },
      });
    };

    sendCreateAppSession();
  }, [createAppSession, isStudy, isVisible]);

  return null;
};

export default AppSession;
